import { siteCodeSchema } from '@snap-types/models/enums';

import { siteConfigurations } from './fixtures/configurations';

export function supportsConfigurator(siteCode: string): boolean {
  // V1 is supported if, and only if, the site is listed in the siteConfigurations fixture
  const { success, data } = siteCodeSchema.safeParse(siteCode);
  const hasFixtureConfigurations =
    success && (siteConfigurations[data]?.length ?? 0) > 0;

  return hasFixtureConfigurations;
}
